import React from 'react';
import { painSection } from '../data/copy';
import { OFFER_ANCHOR } from './constants';
export function PainSection() {
  return <section className="bg-pf-cream px-3 py-3 sm:px-4 sm:py-4" data-id="element-133" data-mp="38xerf3fro5n7">
      <div className="mx-auto max-w-4xl" data-id="element-134" data-mp="2uyov3q0ru9zw">
        <h2 className="mb-1 text-center font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-135" data-mp="2uxvw5b820osb">
          {painSection.title}
        </h2>
        <div className="mx-auto mb-1.5 max-w-3xl space-y-0.5 text-center text-[12.5px] font-medium leading-snug text-pf-ink sm:text-base" data-id="element-136" data-mp="2l7b09vjrlyd3">
          {painSection.intro.map(line => <p key={line} data-id="element-137" data-mp="2baxvo2mom03k">{line}</p>)}
        </div>

        <ul className="grid gap-1 sm:grid-cols-2 sm:gap-1.5" data-id="element-138" data-mp="2b8bquar6dyp1">
          {painSection.questions.map(question => <li key={question} data-id="element-139" data-mp="229qb0nd38xry">
              <a href={OFFER_ANCHOR} className="block rounded-md border-l-4 border-pf-coral bg-white px-2.5 py-1.5 text-[12.5px] font-semibold leading-snug text-pf-navy shadow-sm transition-colors duration-150 ease-out hover:bg-pf-creamDark sm:text-[15px]" data-id="element-140" data-mp="22aj9z25t2izj">
                {question}
              </a>
            </li>)}
        </ul>

        <div className="mt-1.5 text-center text-[12.5px] font-medium leading-snug text-pf-ink sm:text-base" data-id="element-141" data-mp="5g2i6g5dzcll">
          <p data-id="element-142" data-mp="i12m5765vev">{painSection.close[0]}</p>
          <p className="font-display text-[14px] font-extrabold uppercase text-pf-coral sm:text-xl" data-id="element-143" data-mp="ewqmlngpvdn">
            {painSection.close[1]}
          </p>
        </div>
      </div>
    </section>;
}